<template>
  <el-dialog
    title="修改"
    :close-on-click-modal="false"
    :lock-scroll="false"
    :visible.sync="dialogFormVisible"
    width="50%"
    @close="closeDialog"
  >
    <el-form
      ref="form"
      label-position="right"
      :model="form"
      :rules="rules"
      :label-width="formLabelWidth"
    >
      <el-form-item label="分类名称" prop="merchantName">
        <el-col :span="18">
          <el-input v-model.trim="form.name" clearable />
        </el-col>
      </el-form-item>
      <!-- <el-form-item label="联系人" prop="contacts">
         <el-col :span="18">
           <el-input clearable v-model.trim="form.contacts"></el-input>
         </el-col>
       </el-form-item>
       <el-form-item label="联系电话" prop="telephone">
         <el-col :span="18">
           <el-input clearable v-model.trim="form.telephone"></el-input>
         </el-col>
       </el-form-item> -->
      <el-form-item label="图片" prop="icon">
        <el-col :span="18">
          <el-upload
            ref="upload"
            class="avatar-uploader"
            action="/api/tool/oss/upload"
            :show-file-list="false"
            :on-success="handleAvatarSuccess"
            :on-change="beforeAvatarUpload"
            :auto-upload="false"
            :before-upload="validateImage"
          >
            <img v-if="imgUrl" :src="imgUrl" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-col>
      </el-form-item>
      <el-form-item class="crop">
        <el-col :span="18">
          <div class="cropper-container">
            <vue-cropper
              v-show="imgUrl"
              ref="cropper"
              :aspect-ratio="1"
              :src="imgUrl"
              preview=".preview"
              :view-mode="2"
              :drag-mode="'move'"
              :auto-crop-area="1"
              :crop-box-movable="true"
              :crop-box-resizable="false"
            />
            <div style="height: 10px"></div>
            <el-button v-show="imgUrl" type="primary" @click="cropImage"
              >裁剪</el-button
            >

            <div v-show="!imgUrl" class="cropper-placeholder">裁剪区</div>
          </div>
        </el-col>
      </el-form-item>
      <!-- <el-form-item label="跳转url" prop="url">
         <el-col :span="18">
           <el-input clearable v-model.trim="form.url"></el-input>
         </el-col>
       </el-form-item> -->
      <el-form-item label="备注" prop="remark">
        <el-col :span="18">
          <el-input
            type="textarea"
            v-model.trim="form.description"
            clearable
          ></el-input>
        </el-col>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog('normal')">取 消</el-button>
      <el-button type="primary" :loading="loading" @click="handleSubmit"
        >确 定</el-button
      >
    </div>
  </el-dialog>
</template>
<script>
import { shopMerchantCategoryEdit } from "@/api/url";
import VueCropper from "vue-cropperjs";
import "cropperjs/dist/cropper.css";
export default {
  name: "MerchantClassEdit",
  components: {
    VueCropper,
  },
  props: {
    detail: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      dialogFormVisible: true,
      loading: false,
      form: {
        merchantName: "",
        contacts: "",
        telephone: "",
        picture: "",
        url: "",
        remark: "",
      },
      formLabelWidth: "120px",
      imgUrl: "",
      rules: {
        // merchantName: [
        //   { required: true, message: "请输入分类名称", trigger: "blur" },
        //   {
        //     min: 2,
        //     max: 50,
        //     message: "长度在 2 到 50 个字符",
        //     trigger: "blur",
        //   },
        // ],
        // picture: [{ required: true, message: "请上传图片", trigger: "change" }],
      },
    };
  },
  mounted() {
    if (this.detail) {
      const detail = JSON.parse(JSON.stringify(this.detail));
      this.form = { ...detail };
      this.imgUrl = detail.icon;
      this.$nextTick(() => {
        this.$refs.cropper.replace(detail.icon);
      });
    }
  },
  // watch: {
  //   detail: {
  //     handler(val){
  //       if (val) {
  //         const detail = JSON.parse(JSON.stringify(val));
  //         this.form = { ...detail };
  //         this.imgUrl = detail.picture;
  //         console.log("this.$refs.cropper=>", this.$refs.cropper);
  //         if (this.$refs.cropper) {

  //           this.$refs.cropper.replace(detail.picture);
  //         }
  //       }
  //     },
  //     deep: true,
  //     immediate: true,
  //   },
  // },
  methods: {
    closeDialog(type) {
      this.$emit("closeDialog", type);
    },
    validateImage(file) {
      const isImage = file.type.startsWith("image/");
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isImage) {
        this.$message.error("只能上传图片文件!");
        return false;
      }
      if (!isLt2M) {
        this.$message.error("图片大小不能超过 2MB!");
        return false;
      }
      return true;
    },
    handleAvatarSuccess(res) {
      if (res?.data) {
        this.form.picture = res.data;
      }
    },
    beforeAvatarUpload(file) {
      if (typeof FileReader === "function") {
        const reader = new FileReader();
        reader.readAsDataURL(file.raw);
        reader.onload = (event) => {
          this.imgUrl = event.target.result;
          this.$refs.cropper?.replace(event.target.result);
        };
      } else {
        this.$message.error("您的浏览器不支持 FileReader");
      }
    },
    async uploadImage() {
      try {
        const canvas = this.$refs.cropper.getCroppedCanvas({
          width: 100,
          height: 100
        });
        const blob = await new Promise((resolve) =>
          canvas.toBlob(resolve, "image/jpeg", 0.9)
        );
        const file = new File([blob], "cropped-image.jpg", {
          type: "image/jpeg",
        });

        const formData = new FormData();
        formData.append("file", file);
        formData.append("pathName", "coupon");
        const response = await fetch("/api/tool/oss/upload", {
          method: "POST",
          body: formData,
        });
        const data = await response.json();
        if (data?.data) {
          this.form.icon = data.data;
          this.$message.success("图片上传成功");
          return data;
        }
        throw new Error("上传失败");
      } catch (error) {
        this.$message.error("图片上传失败");
        throw error;
      }
    },
    cropImage() {
      this.imgUrl = this.$refs.cropper.getCroppedCanvas().toDataURL();
    },
    async handleSubmit() {
      try {
        await this.$refs.form.validate();
        this.loading = true;
        await this.uploadImage();

        const response = await this.$putRequest(
          `${shopMerchantCategoryEdit()}/${this.form.id}`,
          this.form
        );

        if (response.status === 200) {
          this.$message.success("修改成功");
          this.closeDialog("edit");
        } else {
          throw new Error("修改失败");
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
}
.avatar {
  width: 100px;
  height: 100px;
  object-fit: cover;
}
.cropper-container {
  box-sizing: border-box;
  padding: 20px;
  width: 100%;
  height: 80%;
  border: 1px dashed #ccc;
  border-radius: 10px;
  text-align: center;
  line-height: 50px;
}
.cropper-placeholder {
  color: #909399;
}
</style>